
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo/ocr",
      function () {
        return require("private-next-pages/demo/ocr.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo/ocr"])
      });
    }
  